// Classes.
import {BaseLocator} from './../locators/base.locator';
import {NewsPopularLocatorComponent} from './../locators/news-popular.locator-component';


export class NewsLocator extends BaseLocator {

  //public name: StringLocatorComponent;
  public popular: NewsPopularLocatorComponent;

  constructor() {
    super('news');
    this.addComponentByType('popular');
  }
}

